mutation ToggleContextDocumentUsage($input: ContextDocumentUsageToggleInput!) {
    contextDocumentUsageToggle(input: $input) {
        id
        isIncluded
        effectiveStatus
    }
}
